import { render, staticRenderFns } from "./Breadcrumb.vue?vue&type=template&id=0f18bd34&scoped=true"
import script from "./Breadcrumb.js?vue&type=script&lang=js&external"
export * from "./Breadcrumb.js?vue&type=script&lang=js&external"
import style0 from "./Breadcrumb.scss?vue&type=style&index=0&id=0f18bd34&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f18bd34",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotLink: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/HotLink/HotLink.vue').default})
